import { PanelBarItem } from '@progress/kendo-react-layout';

export const AccordionItem = PanelBarItem;
